import Link from "next/link";

function ArrowButton() {
  return (
    <div
      className="w-10 h-10 sm:w-14 sm:h-14 rounded-2xl flex items-center justify-center shadow-md cursor-pointer hover:opacity-90 transition-opacity flex-shrink-0"
      style={{ background: "linear-gradient(135deg, #8aba28, #056686)" }}
    >
      <svg
        width="18"
        height="18"
        viewBox="0 0 24 24"
        fill="none"
        stroke="white"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M9 18l6-6-6-6" />
      </svg>
    </div>
  );
}

export function ServicesSection() {
  return (
    <section className="w-full max-w-7xl mx-auto px-4 sm:px-6 py-12 sm:py-20 font-sans">
      <div className="text-center mb-10 sm:mb-16 px-2">
        <h1 className="text-[clamp(26px,5vw,64px)] font-bold text-[#373A74] leading-tight mb-4">
          Two Core Capabilities Driving
          <br className="hidden sm:block" />
          Digital Transformation
        </h1>
        <p className="text-[#373A74] text-[clamp(14px,1.8vw,24px)] mt-4 max-w-2xl mx-auto">
          Cybersecurity and AI solutions built to secure, scale, and deliver
          real-world impact.
        </p>
      </div>

      <div className="relative grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-10 items-start">
        <div className="bg-[#F3F4F6] rounded-3xl p-6 sm:p-10 sm:pr-16 relative z-10">
          <Link href="/cybersecurity-compliances">
            <div className="flex justify-between items-start mb-4">
              <h2 className="text-[clamp(20px,2.5vw,28px)] font-extrabold text-[#2d3a6b] leading-tight">
                Cybersecurity &<br />
                Compliance
              </h2>
              <ArrowButton />
            </div>
          </Link>
          <p className="text-[#5b647f] text-sm leading-relaxed max-w-md pb-4 lg:pb-[80px]">
            End-to-end security services from assessments to enterprise-grade
            compliance platforms. Certified professionals (CISSP, CISM, ISO
            27001 Lead Auditors).
          </p>

          <div className="lg:absolute lg:-bottom-[50%] lg:left-1/3 w-full lg:w-[220px] rounded-2xl overflow-hidden shadow-lg mt-4 lg:mt-0">
            <video
              className="w-full h-full object-cover scale-[1.015]"
              src="/AdminReduction.mp4"
              autoPlay
              muted
              loop
              playsInline
            />
          </div>
        </div>

        <div className="relative flex flex-col gap-8">
          <div className="w-full lg:absolute lg:-top-[80%] lg:-right-[10%] lg:w-[280px] rounded-3xl overflow-hidden shadow-2xl z-20 bg-white lg:mb-0 mb-4">
            <video
              className="w-full h-full object-cover"
              src="/OutcomeKpis.mp4"
              autoPlay
              muted
              loop
              playsInline
            />
          </div>

          <div className="bg-[#F3F4F6] rounded-3xl p-6 sm:p-10 lg:pt-20 relative z-10">
            <Link href="/product-services">
              <div className="flex justify-between items-start mb-4">
                <h2 className="text-[clamp(20px,2.5vw,28px)] font-extrabold text-[#2d3a6b] leading-tight">
                  AI Products &<br />
                  Services
                </h2>
                <ArrowButton />
              </div>
            </Link>
            <p className="text-[#5b647f] text-sm leading-relaxed max-w-md">
              Production-ready AI platforms (AxesIQ) and full-stack digital
              transformation services for e-commerce, membership management, and
              retail visualisation.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ServicesSection;
